async function removeLegacyOfflineCache() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));
  }

  if ('caches' in window) {
    const cacheNames = await window.caches.keys();
    await Promise.all(cacheNames.map(cacheName => window.caches.delete(cacheName)));
  }
}

export function unregister() {
  const cleanUp = () => {
    removeLegacyOfflineCache().catch(() => {
      // Cache cleanup is best-effort and must never prevent the site from loading.
    });
  };

  if (document.readyState === 'complete') {
    cleanUp();
  } else {
    window.addEventListener('load', cleanUp, { once: true });
  }
}

export default unregister;
